export const images = {
  methods: {
    imageAsBase64: img => {
      const reader = new FileReader()

      return new Promise((resolve, reject) => {
        reader.readAsDataURL(img)

        reader.onerror = error => reject(error)
        reader.onloadend = () => resolve(reader.result)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/images.js